import { useRuntimeConfig } from '#imports'
import { computed } from 'vue'

import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'

import type { AlgoliaDomain } from '../types.ts'

export function useIsProxyActivated(domain: AlgoliaDomain) {
  const { ALGOLIA_PROXY_DOMAINS, ALGOLIA_HOST } = useRuntimeConfig().public
  const { market } = useMarketplace()

  const isDomainActivated = (ALGOLIA_PROXY_DOMAINS as string)?.includes(domain)
  const isHostSet = !!ALGOLIA_HOST
  const isProxyActivated = isDomainActivated && isHostSet

  const host = computed(() =>
    ((ALGOLIA_HOST as string) || '')?.replaceAll(
      '{market.domain}',
      market.domain,
    ),
  )

  return {
    isProxyActivated,
    host,
  }
}
